<template>
    <promotion-resources
        v-bind="form"
        :key="selectedSubCampaign._id"
        :edit-context="selectedSubCampaign"
    />
</template>

<script>
import { mapGetters } from 'vuex';

const form = {
    vuexModule: 'subCampaigns',
    editMode: true,
    editEvent: 'subCampaignUpdated',
    fields: [
        {
            fieldName: 'resourceDefinitions',
            editable: true,
        },
    ],
};

export default {
    data: () => ({
        form,
    }),
    computed: {
        ...mapGetters('subCampaigns', ['selectedSubCampaign']),
    },
};
</script>
